<template>
    <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.07969 7.36859L0.399688 2.68859C0.179688 2.46859 0.069688 2.18859 0.069688 1.84859C0.0696881 1.50859 0.179688 1.22859 0.399688 1.00859C0.619688 0.788594 0.899688 0.678593 1.23969 0.678593C1.57969 0.678593 1.85969 0.788594 2.07969 1.00859L7.59969 6.52859C7.71969 6.64859 7.80469 6.77859 7.85469 6.91859C7.90469 7.05859 7.92969 7.20859 7.92969 7.36859C7.92969 7.52859 7.90469 7.67859 7.85469 7.81859C7.80469 7.95859 7.71969 8.08859 7.59969 8.20859L2.07969 13.7286C1.85969 13.9486 1.57969 14.0586 1.23969 14.0586C0.899687 14.0586 0.619687 13.9486 0.399687 13.7286C0.179687 13.5086 0.069687 13.2286 0.0696871 12.8886C0.0696871 12.5486 0.179687 12.2686 0.399687 12.0486L5.07969 7.36859Z"
            fill="#5625CC" />
    </svg>

</template>
<script>
export default {
    name: "NextBtnColourful",
    components: {},
};
</script>
<style lang="scss">
</style>